





import Vue from 'vue';
import * as highlight from 'prismjs';

export default Vue.extend({
    props: {
        lang: {
            type: String,
            required: true,
            default: '',
        },
        code: {
            type: String,
            required: true,
        },
    },
    async mounted() {
        await highlight.highlightAll(true);
    },
});
